export default {"src":"/_next/static/media/get-approved.ab8500ba.svg","height":120,"width":121};